// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3OHPR","box":"WorkspacesBox_box__2hxAF","node":"WorkspacesBox_node__2I1ZA"};